<template>
  <vs-row>
    <div v-if="isBrowseContent">
      <vs-popup fullscreen title="Browse Item" :active.sync="isBrowseContent"
      class="browse_modal_item"
      >
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="repository_id"
          @getImportFile="getImportFile"
          :multipleSelect="false"
        ></import-browse-files-model>
        <!-- <div slot="footer">jfjfjf</div> -->
      </vs-popup>
    </div>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
      <vs-card class="cstm-card w-full mb-4 collapse-cstm-card">
        <div class="collapse-item">
          <div
            class="flex justify-between header"
            slot="header"
            :class="{ activeCollapse: isCollapseCard }"
          >
            <h5>File</h5>
            <!-- <span class="material-icons">keyboard_arrow_down</span> -->
          </div>
          <div
            class="collapseContent"
            v-show="isCollapseCard"
            :class="{ active: isCollapseCard }"
          >
            <div class="flex justify-between">
              <!-- <vs-button class="mb-2" color="dark" type="filled" icon="menu"> -->
                <!-- <span v-if="theme != 'list'">List View</span>
              <span v-if="theme == 'list'">Grid View</span> -->
              <!-- </vs-button> -->
             
            </div>

            <!-- <pre>{{fileRecords}}</pre> -->

            <!-- {{lesson_file_index}} -->
            <!-- {{imagevalidation}} -->
              <div class="cstm_vuefileagent_holder">
                <VueFileAgent
                  @isBrowseContent="isBrowseContent = true"
                  ref="vueFileAgent"
                  :theme="theme"
                  :multiple="false"
                  :deletable="true"
                  :meta="true"
                  :accept="imagevalidation"
                  :maxSize="'10000MB'"
                  :maxFiles="14"
                  :linkable="true"
                  :helpText="imageHint"
                  :errorText="{
                    type: 'Invalid file type. Only excel Allowed',
                    size: 'File should not exceed 10MB in size',
                  }"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  v-model="fileRecords"
                  @upload:error="uploadEvent('upload:error', $event)"
                ></VueFileAgent>
                <p class="or_text_holder">(or)</p>
                <vs-tooltip class="inline-block align-bottom" color="primary"
                  text="Import File From Your Existing System"
                >
                  <vs-button
                    icon="folder_special"
                    class="mb-6 mx-1 icon_large_btn"
                    color="primary"
                    type="border"
                     @click="isBrowseContent = true"
                   
                    ></vs-button
                  >
                </vs-tooltip>
                <vs-tooltip class="inline-block align-bottom" color="primary"
                  text="Select files From Gdrive"
                >
                  <vs-button
                    class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
                    color="primary"
                    type="border"
                      @click="driveIconClicked()"
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "/><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "/><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "/></g></svg>
                  </vs-button>
                </vs-tooltip>
              </div>

            <div>
              <vs-divider />
              <vs-button
                :disabled="!fileRecordsForUpload.length"
                @click="uploadFiles()"
              >
                Upload {{ fileRecordsForUpload.length }} file
              </vs-button>
            </div>
          </div>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import {repository} from '@/mixins/repository.js'
import { getUploadedFilesId } from '@/api/assignment-question'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesExcel.vue'
import {GoogleAuthorization} from '@/mixins/common/excelGoogleAuth.js'
export default {
  name: 'FileUpload',
  components: { ImportBrowseFilesModel },
  mixins:[GoogleAuthorization,repository],
  props: {
    file_repository_id: {
      required: false,
      type: Number,
      default: 0
    },
     module_id: {
      required: false,
      type: Number,
      default: 0
    },
   
  },
  data () {
    return {
      section_type:'courseHeader',
      deletedIndex: null,
      isBrowseContent: false,
      isCollapseCard: true,
      theme: 'grid',
      imageHint: 'Choose file or drag & drop here',
      imagevalidation: '.xlsx,.csv',
      auto: true,
      fileRecords: [],
      uploadUrl: '',
      ///file/upload/${platform_customer_id}
      uploadHeaders: { 'X-Test-Header': 'vue-file-agent', 'Authorization': '' },
      fileRecordsForUpload: [],
      importedFileData: [] // maintain an upload queue
    }
  },
  // config.headers['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`

  created () {
    this.getRepositoryId(this.module_id)
    /*  if (this.filesInfo.length) {
      this.fileRecords = this.filesInfo.map((ele) => {
        return {
          name: ele.file.file_name,
          sizeText: this.bytesToSize(ele.file.size),
          size: ele.file.size,
          type: ele.file.file_type,
          url: ele.file.file_path
        }
      })
    } */
    const customer_id = this.$store.getters.customerId
    const imageUploadUrl = process.env.VUE_APP_EXCEL_UPLOAD_URL
    this.uploadUrl = `${imageUploadUrl}${customer_id}`
    this.uploadHeaders.Authorization = `Bearer ${JSON.parse(
      localStorage.getItem('access_token')
    )}`
  /*   if (this.section_type === 'courseHeader') {
      this.imagevalidation = 'image/*'
      this.imageHint = 'Choose course image or drag & drop here'
    } */
  },
  mounted () {
    /*  if (this.section_type !== 'courseHeader') {

      const browseComponent = Vue.extend(BrowseComponentDesign)

      const component = new browseComponent().$mount()
      component.$on('isBrowseContent', () => {
        this.isBrowseContent = true
      })


      const list = this.$refs.vueFileAgent.$el.getElementsByClassName('file-preview-wrapper')

      list[0].after(component.$el)
    } */
    /*list[0].insertBefore(component.$el, list[0])

    this.$refs.vueFileAgent.$el.parentNode.insertBefore(component.$el, list[0].nextSibling)
      */
  },
  methods: {
    switchTheme () {
      this.theme = this.theme === 'list' ? 'default' : 'list'
    },
    uploadEvent (eventName, data) {},
    uploadFiles () {
      // Using the default uploader. You may use another uploader instead.
      // const data = this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload)

      const data = this.$refs.vueFileAgent.upload(
        this.uploadUrl,
        this.uploadHeaders,
        this.fileRecordsForUpload,
        function createFormData (fileData) {
          const formData = new FormData()
          formData.append('excel', fileData.file) // this is important! - the actual file for upload
          return formData // edit: fixed. Thanks to Chauhan-Nitesh for the comment below
        }
      )

      this.$vs.loading({
        type: 'material',
        text: 'Please wait we are uploading file'
      })

      data
        .then((response, error) => {
          console.log(response)
          // const cdn = response[0].data.data.cdn

          if (response) {
            for (let i = 0; i < response.length; i++) {          
              this.$emit('getFileInfo', response[i].data.data.files)
              this.$vs.loading.close()

            }
          } else {
            this.$vs.loading.close()
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
        })
        .finally(this.$vs.loading.close())
      this.fileRecordsForUpload = []
    },
    deleteUploadedFile () {
      if (
        this.section_type === 'courseHeader' ||
        this.section_type === 'CourseComponent'
      ) {
        this.$emit('deletedIndex', this.deletedIndex)
      } else if (
        this.section_type === 'lessonComponent' ||
        this.section_type === 'topiccomponent'
      ) {
        const fileIdObject = {
          lesson_file_index: this.lesson_file_index,
          fileIndex: this.deletedIndex
        }
        this.$emit('deletedIndex', fileIdObject)
      }
    },
    filesSelected (fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter(
        (fileRecord) => !fileRecord.error
      )

      if (this.section_type === 'courseHeader') {
        this.fileRecordsForUpload = fileRecordsNewlySelected
        if (!validFileRecords.length) {
          this.fileRecordsForUpload.length = 0
        }
      } else {
        // this.imagevalidation = ''

        this.fileRecordsForUpload =
          this.fileRecordsForUpload.concat(validFileRecords)
      }
    },
    onBeforeDelete (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) this.fileRecords.splice(k, 1)
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Please Confirm',
          text: 'Are you sure you want to delete this file?',
          accept: this.acceptAlert,
          parameters: fileRecord
        })
      }
    },
    acceptAlert (fileRecord) {
      const index = this.fileRecords.indexOf(fileRecord)

      this.deletedIndex = index

      this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event

      // this.$refs.vueFileAgent.deleteFileRecord(fileRecord) // will trigger 'delete' event
    },
    fileDeleted (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      } else {
        this.deleteUploadedFile(fileRecord)
      }
    },
    async getUploadFiles (file_id_payload) {
      const res = await getUploadedFilesId(file_id_payload)

      if (res.data.message === 'files.createFile') {
        /* const newRecord = this.generateFileForVueAgent(response[i].data.data.files[0])

               */
       

        const fileInfo = res.data.data.files[0]
        this.$vs.notify({
          title: 'Success',
          text: 'File Uploaded Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 1000
        })
        //

        // const fileIdObject = {
        //   question_index:this.question_detail_index,
        //   file_id
        // }

        this.$vs.loading.close()

        //section type checking '
        this.$emit('getFileInfo', fileInfo)
        

        //section type checking
      }
    },
    bytesToSize (bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return 'n/a'
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return `${bytes} ${sizes[i]})`
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
    },
    getImportFile ({ file_id, fileInfo }) {
      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)
      if (this.section_type === 'courseHeader') {
        const fileObject ={
          id: file_id[0],
          file_path:fileInfo[0].file_path
        }
        this.$emit('getFileInfo', fileObject)
      } else if (this.section_type === 'CourseComponent') {
        const importFileRecords = this.getImportedFile(fileInfo)

        this.filesInfo.push(
          ...importFileRecords.map((ele) => {
            return {
              file: {
                file_name: ele.name,
                file_path: ele.url,
                size: ele.size,
                file_type: ele.type
              }
            }
          })
        )

        this.fileRecords.push(...importFileRecords)

        this.$emit('getFileId', file_id)
      } else if (
        this.section_type === 'lessonComponent' ||
        this.section_type === 'topiccomponent'
      ) {
        const fileIdObject = {
          lesson_file_index: this.lesson_file_index,
          file_id
        }
        const importFileRecords = this.getImportedFile(fileInfo)

        this.filesInfo.push(
          ...importFileRecords.map((ele) => {
            return {
              file: {
                file_name: ele.name,
                file_path: ele.url,
                size: ele.size,
                file_type: ele.type
              }
            }
          })
        )

        this.fileRecords.push(...importFileRecords)

        // this.fileRecords.push(...importFileRecords)

        this.$emit('getFileId', fileIdObject)
      }
    },
    generateFileForVueAgent (ele) {
      return {
        file_id: ele.file.id,
        name: ele.file.file_name,
        sizeText: this.bytesToSize(ele.file.size),
        size: ele.file.size,
        type: ele.file.file_type,
        url: ele.file.file_path,
        upload: {
          data: true,
          error: false
        }
      }
    },
    getImportedFile (fileInfo) {
      return fileInfo.map((ele) => {
        return {
          name: ele.file_name,
          sizeText: this.bytesToSize(ele.size),
          size: ele.size,
          type: ele.file_type,
          url: ele.file_path,
          color: 'green',
          upload: {
            data: true,
            error: false
          }
        }
      })
    }
  }
}
</script>
